import React from 'react'
import classNames from 'classnames'
import { DepartmentNavigationTopLevelItemFragment } from '../../../../../NavHierarchyFragments.generated'
import TopLevelItem from '../TopLevelItem'
import SubSectionItems from '../SubSectionItems'
import styles from './styles.css'

interface SubSectionsColumnProps {
  topLevelItems: DepartmentNavigationTopLevelItemFragment[]
  isVisible: boolean
  isTwoColumn: boolean
}

const SubSectionsColumn: React.FC<SubSectionsColumnProps> = ({
  topLevelItems,
  isVisible,
  isTwoColumn
}) => {
  // We consider tablet as a 'fullSize' resolution
  const filteredTopLevelItems = topLevelItems.filter(topLevelItem => topLevelItem.showIfFullSize)

  return (
    <div
      className={classNames(styles.subSection, {
        [styles.visible]: isVisible
      })}
    >
      {filteredTopLevelItems.map(topLevelItem => {
        const subSections = topLevelItem.subSections

        return (
          <div
            className={classNames(styles.subSectionGroup, {
              [styles.twoColumn]: isTwoColumn
            })}
            key={`tablet${topLevelItem.id}`}
          >
            <TopLevelItem key={topLevelItem.id} topLevelItem={topLevelItem} />
            {subSections.length > 0 && (
              <SubSectionItems topLevelId={topLevelItem.id} subSections={subSections} />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default SubSectionsColumn
